var storage = $.localStorage;
var compare = {};
var total_compare = 3;

if (storage.isSet('compare')) {
    compare = storage.get('compare');
} else {
    storage.set('compare', {});
}


$('.swatch :radio').change(function () {
    var optionIndex = $(this).closest('.swatch').attr('data-option-index');
    var optionValue = $(this).val();
    $(this).closest('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
});

/* $("#product-featured-image").elevateZoom({
    gallery: "ProductThumbs",
    cursor: "pointer",
    galleryActiveClass: "active",
    imageCrossfade: !0,
    scrollZoom: !0,
    onImageSwapComplete: function() {
        $(".zoomWrapper div").hide()
    }
});*/
function responsiveMenuPopup($this) {
    if (document.body.clientWidth > 991) {
        var isRtl = $('body').hasClass('lang-rtl');
        var wrapWidthPopup = $($this).find('.site-nav-dropdown ').outerWidth(true);
        if (wrapWidthPopup !== null && wrapWidthPopup !== undefined) {
            var menuWidth = $('.desktop-megamenu').width();
            var posliWidth = $($this).offset();
            if (isRtl) {
                var menuLeft = (menuWidth - ($($this).offset().left + $($this).outerWidth()));
            } else {
                var menuLeft = posliWidth.left;
            }
            if ($('.tv-main-div').hasClass('tv-box-layout')) {
                var boxLayout = $('.tv-main-div.tv-box-layout');
                if (isRtl) {
                    var boxLeft = (menuWidth - ($(boxLayout).offset().left + $(boxLayout).outerWidth()));
                } else {
                    var boxLeft = $(boxLayout).offset().left;
                }
                menuLeft -= boxLeft;
            }
            if ((menuLeft + wrapWidthPopup) > menuWidth) {
                if (isRtl) {
                    $($this).find('.site-nav-dropdown ').css('left', 0);
                } else {
                    $($this).find('.site-nav-dropdown ').css('right', 0);
                }
            }
        }
    }
}
$(document).on('touchstart mouseover', '.tvmenu-dropdown .tvmain-top-title', function (e) {
    responsiveMenuPopup(this);
});
/*horizontalmenu*/
//=========================Start Animation==============================
$(window).load(function () {
    var ENVTCMSCUSTOMSETTING_ANIMATION_CSS = 1;
    if (typeof ENVTCMSCUSTOMSETTING_ANIMATION_CSS !== undefined && ENVTCMSCUSTOMSETTING_ANIMATION_CSS == '1') {
        function hb_animated_contents() {
            $(".hb-animate-element:in-viewport").each(function (i) {
                //=============Animation============ 
                var $this = $(this);
                if (!$this.hasClass('hb-in-viewport')) {
                    setTimeout(function () {
                        $this.addClass('hb-in-viewport')
                    }, 100 * i)
                }
            })
        }
        $(document).scroll(function () {
            hb_animated_contents();
        });
        $(window).on('load', function () {
            hb_animated_contents();
        });
    }
});
//=========================End Animation==============================
Shopify.optionsMap = {};
Shopify.updateOptionsInSelector = function (selectorIndex) {
    switch (selectorIndex) {
        case 0:
            var key = 'root';
            var selector = $('.single-option-selector:eq(0)');
            break;
        case 1:
            var key = $('.single-option-selector:eq(0)').val();
            var selector = $('.single-option-selector:eq(1)');
            break;
        case 2:
            var key = $('.single-option-selector:eq(0)').val();
            key += ' / ' + $('.single-option-selector:eq(1)').val();
            var selector = $('.single-option-selector:eq(2)');
    }

    var initialValue = selector.val();
    selector.empty();
    var availableOptions = Shopify.optionsMap[key];
    if (availableOptions && availableOptions.length) {
        for (var i = 0; i < availableOptions.length; i++) {
            var option = availableOptions[i];
            var newOption = $('<option></option>').val(option).html(option);
            selector.append(newOption);
        }
        $('.swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function () {
            if ($.inArray($(this).attr('data-value'), availableOptions) !== -1) {
                $(this).removeClass('soldout').show().find(':radio').removeAttr('disabled', 'disabled').removeAttr('checked');
            } else {
                $(this).addClass('soldout').hide().find(':radio').removeAttr('checked').attr('disabled', 'disabled');
            }
        });
        if ($.inArray(initialValue, availableOptions) !== -1) {
            selector.val(initialValue);
        }
        selector.trigger('change');
    }
};
Shopify.linkOptionSelectors = function (product) {
    // Building our mapping object.
    for (var i = 0; i < product.variants.length; i++) {
        var variant = product.variants[i];
        if (variant.available) {
            // Gathering values for the 1st drop-down.
            Shopify.optionsMap['root'] = Shopify.optionsMap['root'] || [];
            Shopify.optionsMap['root'].push(variant.option1);
            Shopify.optionsMap['root'] = Shopify.uniq(Shopify.optionsMap['root']);
            // Gathering values for the 2nd drop-down.
            if (product.options.length > 1) {
                var key = variant.option1;
                Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
                Shopify.optionsMap[key].push(variant.option2);
                Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
            }
            // Gathering values for the 3rd drop-down.
            if (product.options.length === 3) {
                var key = variant.option1 + ' / ' + variant.option2;
                Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
                Shopify.optionsMap[key].push(variant.option3);
                Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
            }
        }
    }
    // Update options right away.
    Shopify.updateOptionsInSelector(0);
    if (product.options.length > 1) Shopify.updateOptionsInSelector(1);
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
    // When there is an update in the first dropdown.
    $(".single-option-selector:eq(0)").change(function () {
        Shopify.updateOptionsInSelector(1);
        if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
        return true;
    });
    // When there is an update in the second dropdown.
    $(".single-option-selector:eq(1)").change(function () {
        if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
        return true;
    });
};

/*live search*/
$(document).on('click', '.jstvsearch-btn-wrap', function (event) {
    event.preventDefault();
    $('.jstvsearch-main-box').show();
});
$(document).on('keyup', '.jstvsearch-input-box', function (event) {
    var search_element = $(this).val();

    var html = '';
    if (search_element.length >= 3) {
        var searchURL = '/search?type=product&q=*' + search_element + '*';
        $.getJSON(searchURL + '&view=json', function (data) {
            html += '<div class="tvcmssearch-dropdown clearfix">';
            html += '<div class="tvcmssearch-dropdown-wrapper">';                
            $.each(data.results, function (index, item) {
                html += '<div class="tvsearch-all-dropdown-wrapper">';
                html += '<div class="tvsearch-dropdown-wrapper">';
                html += '<a href="' + item.url + '">';
                html += '<div class="tvsearch-dropdown-img-block">';
                html += '<img src="' + item.thumbnail + '" alt="">';
                html += '</div>';
                html += '<div class="tvsearch-dropdown-content-box">';
                html += '<div class="tvsearch-dropdown-title">' + item.title + '</div>';
                html += '<div class="jsproduct-price-and-shipping product-price-and-shipping">';
                html += '<span class="price">' + item.price + '</span>';
                if (item.sale != 00) {
                    html += '<span class="regular-price">' + item.sale + '</span>';
                }
                html += '</div>';
                html += '</div>';
                html += '</a>';
                html += '</div>';
                html += '</div>';
            });
            if (data.results_count == 0) {
                html += 'Product is not available';
            }
            if (data.results_count > 15) {
                html += '<div class="tvsearch-more-search-wrapper clearfix">';
                html += '<div id="jslivesearch" class="tvsearch-more-search tvall-inner-btn">More Result</div>';
                html += '</div>';
            }
            html += '</div>';
            html += '</div>';
            $('.header-1 #jssearchresult').html(html);
            $('.header-2 #jssearchresult').html(html);
            $('.header-3 #jssearchresult').html(html);
            $('.header-4 #jssearchresult').html(html);
            $('.header-5 #jssearchresult').html(html);
        });
    } else {
        html += '<div class="tvcmssearch-dropdown clearfix">';
        html += 'Minimum Three character enter';
        html += '</div>';
        $('.header-1 #jssearchresult').html(html);
        $('.header-2 #jssearchresult').html(html);
        $('.header-3 #jssearchresult').html(html);
        $('.header-4 #jssearchresult').html(html);
        $('.header-5 #jssearchresult').html(html);
    }
});
$(document).on('click', '#jslivesearch', function (event) {
    $(".header-1 .tvsearch-form").submit();
    $(".header-2 .tvsearch-form").submit();
    $(".header-3 .tvsearch-form").submit();
    $(".header-4 .tvsearch-form").submit();
    $(".header-5 .tvsearch-form").submit();
});
/*live search*/

/*Start Compare Product*/
function compare_to_table(data) {
    if (Object.keys(data).length <= 0) {
        return '';
    }
    var html = '';
    var i = 0;
    var end_check = (Object.keys(data).length - 1);
    var width_tr = (end_check > 0) ? (90 / (Object.keys(data).length)) : 90;
    var data_html = '';
    for (i = 0; i <= end_check; i++) {
        var el = data[i];
        var is_sale = false;
        if (el.compare_at_price > el.price) {
            is_sale = true
        }

        data_html = data_html + '<th class="jsitem-row tvproduct-compare-remove ' + el.handle + '"  id="product-' + el.id + '"><button type="button" class="close btn jsremove-compare center-block" aria-label="Close" data-handle="' + el.handle + '"> Remove <i class="fa fa-times" aria-hidden="true"></i></button></th>';
        //Start title 
        if (i == 0) {
            html = html + '<tr>';
            html = html + '<th width="15%" class="product-name" >Product Name</th>';
        }
        html = html + '<td width="' + width_tr + '%"  class=" tvcompare-product-title  ' + el.handle + ' jsgrid-link__title"> ' + el.title + '  </td>';
        if (i >= end_check) {
            html = html + '</tr>';
        }
        // End Title 
    }
    for (i = 0; i <= end_check; i++) {
        var el = data[i];
        var is_sale = false;
        if (el.compare_at_price > el.price) {
            is_sale = true
        }
        if (i == 0) {
            html = html + '<tr>';
            html = html + '<th width="15%" class="product-name " >Product Image</th>';

        }
        // start product image
        html = html + '<td width="' + width_tr + '%" class="jsitem-row product-thumbnail tvcompare-product-image ' + el.handle + '" id="product-' + el.variants[0].id + '"> <img src="' + el.featured_image + '" width="150" height="150" class="featured-image" alt="" /> ' + '<div class="product-price jsproduct-price-and-shipping"> ';
        if (is_sale) {
            html = html + '<span class="price-sale"><span class="money" data-currency-' + Currency.currentCurrency + '="' + convert_currency(el.price, '11') + '">' + convert_currency(el.price, '11') + '</span></span>';
        } else {
            html = html + '<span class="price-sale"><span class="money" data-currency-' + Currency.currentCurrency + '="' + convert_currency(el.price, '11') + '">' + convert_currency(el.price, '11') + '</span></span>';
        }
        if (convert_currency(el.compare_at_price, 'nosymbol') > 0) {
            html = html + '<span class="visually-hidden">Regular price</span> <s>' + convert_currency(el.compare_at_price, '11') + '</s>';
        }
        html = html + '</div>';
        //convert_currency(el.price,'3');

        if (el.variants.length > 1) {
            html = html + '<a class="tvall-inner-btn" href="#" onclick="location.href=\'/products/' + el.handle + '\'">Select options</a>';
        } else {
            html = html + '<div class="tvproduct-cart-btn">';
            html = html + '<form action="/cart/add" method="post" class="variants clearfix" id="jscart-form-' + el.variants[0].id + '">';
            html = html + '<input type="hidden" name="id" value="' + el.variants[0].id + '" />';
            html = html + '<a data-toggle="tvtooltip" title="Add to Cart" data-pid="' + el.variants[0].id + '" class="tvtheme-btn jsadd-cart-btn add-cart-btn add-to-cart"><span><i class="material-icons shopping-cart">&#xe8cc;</i>Add to Cart</span></a>';
            html = html + '</form>';
            html = html + '</div>';
        }


        html = html + '<p   class="' + el.handle + ' jsgrid-link__title"> ' + el.title + '  </p>';

        html = html + ' </td>';

        if (i >= end_check) {
            html = html + '</tr>';
        }
        // End product image
    }
    for (i = 0; i <= end_check; i++) {
        var el = data[i];
        var is_sale = false;
        if (el.compare_at_price > el.price) {
            is_sale = true
        }
        if (i == 0) {
            html = html + '<tr>';
            html = html + '<th width="15%" class="product-name" >Product Description</th>';

        }
        html = html + '<td width="' + width_tr + '%" class=" tvcompare-product-desc ' + el.handle + ' "> <p class="description-compare"> ' + el.description.replace(/(<([^>]+)>)/ig, "").split(" ").splice(0, 15).join(" ") + "..." + ' </p> </td>';
        if (i >= end_check) {
            html = html + '<tr>';
        }
    }
    for (i = 0; i <= end_check; i++) {
        var el = data[i];
        var is_sale = false;
        if (el.compare_at_price > el.price) {
            is_sale = true
        }
        if (i == 0) {
            html = html + '<tr>';
            html = html + '<th width="15%" class="product-name tvcompare-product-avaibal" >  Availability  </th>';

        }
        var avai_stock = (el.available) ? window.available_stock : window.unavailable_stock;
        html = html + '<td   width="' + width_tr + '%" class="available-stock ' + el.handle + '"> <p> Available </p> </td>';
        if (i >= end_check) {
            html = html + '<tr>';
        }
    }
    $(".th-compare").html('<td>Action</td>' + data_html);
    $("#table-compare").html(html);
    $(document).on('click', '.add-to-cart', function (event) {
        event.preventDefault();
        if ($(this).attr("disabled") != "disabled") {
            var r = $(this).parents(".jsitem-row");
            var i = $(r).attr("id");
            i = i.match(/\d+/g);

            var s = $("#jscart-form-" + i + " select[name=id]").val();
            if (!s) {
                s = $("#jscart-form-" + i + " input[name=id]").val()
            }

            var o = $("#jscart-form-" + i + " input[name=quantity]").val();
            if (!o) {
                o = 1
            }
            var a = $(r).find(".featured-image").attr("src");
            var p = $(r).find(".jsgrid-link__title").text();
            var amt = $(r).find(".product_price span.money").text();

            compareAjaxAddToCart(s, o, a, p, amt);

        }
        return false
    });
}

function compareAjaxAddToCart(n, r, a, p, amt) {

    $.ajax({
        type: "post",
        url: "/cart/add.js",
        data: "quantity=" + r + "&id=" + n,
        dataType: "json",
        beforeSend: function () {
            $(".jsajax-success-compare-modal").fadeOut(500);
            showLoading();
        },
        success: function (n) {
            hideLoading();
            showModal(".jsajax-success-modal");
            $(".jsajax-success-modal").find(".jsajax-product-image").attr("src", a);
            $(".jsajax-success-modal").find(".jsadded-to-wishlist").hide();
            // $(".jsajax-success-modal").find(".jsadded-to-cart").show();
            $(".jsajax-success-modal").find(".jsajax-product-title").text(p);
            $(".jsajax-success-modal").find(".jsajax_price").text(amt);
            updateDropdownCart();
        },
        error: function (n, r) {
            hideLoading();
            $(".jsajax-error-message").text(e.parseJSON(n.responseText).description);
            showModal(".jsajax-error-modal");
        }
    });
}

function modal_compare(compare) {
    if (!$.isEmptyObject(compare)) {
        var list_id = '';
        var json_compare = [];
        var check_end = 0;
        var compare_size = (Object.keys(compare).length - 1);
        $.each(compare, function (index, el) {
            var json_url = "/products/" + el + ".js";
            if ($.trim(el) != "") {
                jQuery.getJSON(json_url, function (product) {
                    json_compare[check_end] = product;
                    if (check_end >= compare_size) {
                        compare_to_table(json_compare);
                    }
                    check_end += 1;
                });
            }
        });
        // $("#jsmodal-compare").fadeIn(500);
    }
}

$(document).on('click', '.jscompare', function (event) {
    // event.preventDefault();
    showLoading();
    /* Act on the event */
    var ethis = $(this);
    var pid = $(this).data('pid');
    compare = storage.get('compare');
    if ($.isEmptyObject(compare)) {
        compare = {};
    }
    var check_compare = true;
    if (Object.keys(compare).length >= total_compare) {
        /*swal({
          title: "info",
          text: window.compare_note,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#4cae4c",
          confirmButtonText: window.confirm_box,
          timer: 3000,
          cancelButtonText: window.cancelButtonText,
          closeOnConfirm: true
        });*/

        modal_compare(compare);

    } else {
        for (var i = 1; i <= 8; i++) {
            if (compare['p' + i] == "" || compare['p' + i] == undefined) {
                compare['p' + i] = pid;
                break;
            } else if (compare['p' + i] == pid) {
                ethis.addClass('added');
                check_compare = false;
                modal_compare(compare);
                break;
            }
        }
        if (check_compare) {
            storage.set('compare', compare);
            modal_compare(compare);
            ethis.addClass('add-success');
            $("[data-pid='" + pid + "']").addClass('added'); //.text(window.added_to_cmp);          
        }
    }
    $('.jstvcompare-count-product').text(Object.keys(compare).length);

    // hideLoading();
});
$(document).on('click', '.jsremove-compare', function (event) {
    // event.preventDefault();
    /* Act on the event */
    var id = $(this).data('handle');
    $("." + id).fadeOut(600).remove();
    $("[data-pid='" + id + "']").removeClass('added add-success'); //.text(window.add_to_cmp);
    $.each(compare, function (index, el) {
        if (el == id) {
            compare[index] = "";
            delete compare[index];
        }
    });
    $('.jstvcompare-count-product').text(Object.keys(compare).length);
    storage.set('compare', compare);
});
/*End Compare Product*/

/*Start Wishlist*/
var cookieName = "wishlistList";
$(document).on('click', '.tvproduct-wishlist-disble', function(e) {
    e.preventDefault();
});

$(document).on('click', '.jsadd-in-wishlist-js', function (e) {
    jQuery.cookie = function (b, j, m) {
        if (typeof j != "undefined") {
            m = m || {}; if (j === null) {
                j = "";
                m.expires = -1
            } var e = ""; if (m.expires && (typeof m.expires == "number" || m.expires.toUTCString)) {
                var f; if (typeof m.expires == "number") {
                    f = new Date();
                    f.setTime(f.getTime() + (m.expires * 24 * 60 * 60 * 1000))
                } else { f = m.expires } e = "; expires=" + f.toUTCString()
            } var l = m.path ? "; path=" + (m.path) : ""; var g = m.domain ? "; domain=" + (m.domain) : ""; var a = m.secure ? "; secure" : "";
            document.cookie = [b, "=", encodeURIComponent(j), e, l, g, a].join("")
        } else { var d = null; if (document.cookie && document.cookie != "") { var k = document.cookie.split(";"); for (var h = 0; h < k.length; h++) { var c = jQuery.trim(k[h]); if (c.substring(0, b.length + 1) == (b + "=")) { d = decodeURIComponent(c.substring(b.length + 1)); break } } } return d }
    };
    e.preventDefault();
    var id = $(this).attr('href');
    if ($.cookie(cookieName) == null) {
        var str = id;
    } else {
        if ($.cookie(cookieName).indexOf(id) == -1) {
            var str = $.cookie(cookieName) + '__' + id;
        }
    }
    $.cookie(cookieName, str, { expires: 14, path: '/' });

    var str = String($.cookie(cookieName)).split("__");
    var totalwish = 0;
    for (var i = 0; i < str.length; i++) {
        if (str[i] != '') {
            totalwish++;
        }
    }
    $.cookie("totalwish", totalwish, { expires: 14, path: '/' });
    $('.jstvwishlist-count-number').text($.cookie("totalwish"));

    $('.jsloadding-wishbutton-' + id).show();
    $('.jsdefault-wishbutton-' + id).remove();
    setTimeout(function () {
        $('.jsloadding-wishbutton-' + id).remove();
        $('.jsadded-wishbutton-' + id).show();
    }, 2000);
    $(this).unbind();


});

$(document).on('click', '.jsbtn-remove', function (n) {
    n.preventDefault();
    var r = $(this).parent();
    var i = r.parents(".jsgrid-item");
    $.ajax({
        type: "POST",
        url: "/contact",
        data: r.serialize(),
        beforeSend: function () {
            showLoading();
        },
        success: function (n) {
            hideLoading();
            var o = $("#product-featured-image").attr("src");
            var wp = $(".jsproduct-single__title").text();
            var wamt = $(".jsproduct-single__price .jsgrid-link__org_price span.money").text();
            $(".jsajax-success-modal").find(".jsadded-to-wishlist").show();
            // $(".jsajax-success-modal").find(".jsadded-to-cart").hide();
            $(".jsajax-success-modal").find(".jsajax-product-image").attr("src", o);
            $(".jsajax-success-modal").find(".jsajax-product-title").text(wp);
            $(".jsajax-success-modal").find(".jsajax_price").text(wamt);
            showModal(".jsajax-success-modal");
        },
        error: function (n, r) {
            hideLoading();
            $(".jstvloading-modal").hide();
            $(".jsajax-error-message").text(e.parseJSON(n.responseText).description);
            showModal(".jsajax-error-modal");
        }
    })
});
/*End Wishlist*/

/*Start Quick View*/
$(document).on('click', '.jsquick-view-text', function () {
    var product = $(this).attr("id");
    $('body').addClass("modal-open");
    Shopify.getProduct(product, function (product) {
        var copy = $('#jstv-quick-view-modal').clone();
        var past = $('.package').html(copy);

        var i = $(past);
        var s = product.description.replace(/(<([^>]+)>)/ig, "");
        s = s.split(" ").splice(0, 40).join(" ") + "...";
        /*product title*/
        i.find(".jstv-quick-view-product-title a h4").text(product.title);
        i.find(".jstv-quick-view-product-title a").attr("href", product.url);
        /*product title*/

        //start product availability
        if (i.find('.jsproduct-inventory span').length > 0) {
            var variant = product.variants[0];
            var inventoryInfo = i.find('.jsproduct-inventory span');
            if (variant.available) {
                if (variant.inventory_management != null) {
                    inventoryInfo.text(window.in_stock);
                    $(inventoryInfo).addClass('tvcmsinstock');
                } else {
                    inventoryInfo.text(window.many_in_stock);
                }
            } else {
                $(inventoryInfo).addClass('tvcmsoutstock');
                inventoryInfo.text(window.out_of_stock);
            }
        }
        //end product availability

        /*product type*/
        if (product.type != "") {
            i.find(".jstvdetail-box .jstvproducttype").text(product.type);
        } else {
            i.find(".jstvdetail-box .tvquick-type").hide();
        }
        /*product type*/

        /*product vendor*/
        if (product.vendor != "") {
            i.find(".jstvdetail-box .jstvproductvendor").text(product.vendor);
        }
        /*product vendor*/


        /*product description*/
        if (s != "") {
            i.find(".jstv-quick-view-product-description p").text(s);
        }
        /*product description*/

        /*product price*/
        i.find("#jsQProductPrice").html(Shopify.formatMoney(product.price, window.money_format));
        /*product price*/

        i.find(".jsproduct-item").attr("id", "product-" + product.id);
        i.find(".variants").attr("id", "product-actions-" + product.id);
        i.find(".variants select").attr("id", "product-select-" + product.id);

        if (product.compare_at_price > product.price) {
            i.find(".jscompare-price").html(Shopify.formatMoney(product.compare_at_price_max, window.money_format)).show();
            i.find(".jstvcmsquickview-Price-amount").addClass("on-sale")
        } else {
            i.find(".jscompare-price").html("");
            i.find(".jstvcmsquickview-Price-amount").removeClass("on-sale")
        }

        if (!product.available) {
            i.find("select, input, .product_price, .total-price, .dec, .inc, .variants label").remove();
            i.find(".add-to-cart-btn").text("Unavailable").addClass("disabled").attr("disabled", "disabled");
        } else {
            i.find(".product_price span").html(Shopify.formatMoney(product.price, window.money_format));
            i.find(".total-price span").html(Shopify.formatMoney(product.price, window.money_format));
            createQuickViewVariantsSwatch(product, i);
        }

        if (!product.available) {
            i.find("select, input, .jstotal-price, .dec, .inc, .variants label").remove();
            i.find(".jsadd-to-cart-btn").text("Unavailable").addClass("disabled").attr("disabled", "disabled");
        } else {
            i.find(".jsproduct_price span").html(Shopify.formatMoney(product.price, window.money_format));
            /*product total price*/
            i.find(".jstotal-price span").html(Shopify.formatMoney(product.price, window.money_format));
            /*product total price*/
            createQuickViewVariants(product, i)
        }

        /*quantity plus*/
        i.find(".button").on("click", function () {
            var n = i.find(".quantity").val();
            r = 1;
            if ($(this).text() == "+") {
                r = parseInt(n) + 1
            } else if (n > 1) {
                r = parseInt(n) - 1
            }
            i.find(".quantity").val(r);
            if (i.find(".jstotal-price").length > 0) {
                updatePricingQuickview();
            }
        });
        /*quantity plus*/

        loadQuickViewSlider(product, i);
        initQuickviewAddToCart();

        if ($('.package .jsquick-view .jstotal-price').length > 0) {
            $('.package .jsquick-view input[name=quantity]').on('change', updatePricingQuickview);
        }
        $(".package #jstv-quick-view-modal").addClass('open');

        $(".package #jstv-quick-view-modal").fadeIn(500);
    });
    return false
});

function updatePricingQuickview() {
    //try pattern one before pattern 2
    var regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;
    var unitPriceTextMatch = $('.package .jsquick-view .jstvcmsquickview-Price-amount').text().match(regex);

    if (!unitPriceTextMatch) {
        regex = /([0-9]+[.|,][0-9]+)/g;
        unitPriceTextMatch = $('.package .jsquick-view .jstvcmsquickview-Price-amount').text().match(regex);
    }
    if (unitPriceTextMatch) {
        var unitPriceText = unitPriceTextMatch[0];
        var unitPrice = unitPriceText.replace(/[.|,]/g, '');
        var quantity = parseInt($('.package .jsquick-view input[name=quantity]').val());
        var totalPrice = unitPrice * quantity;
        var totalPriceText = Shopify.formatMoney(totalPrice, window.money_format);
        regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;
        if (!totalPriceText.match(regex)) {
            regex = /([0-9]+[.|,][0-9]+)/g;
        }
        totalPriceText = totalPriceText.match(regex)[0];

        var regInput = new RegExp(unitPriceText, "g");
        var totalPriceHtml = $('.package .jsquick-view #jsQProductPrice').html().replace(regInput, totalPriceText);
        $('.package .jsquick-view .jstotal-price span').html(totalPriceHtml);
    }
}

function createQuickViewVariants(t, product) {
    if (t.variants.length > 1) {
        for (var r = 0; r < t.variants.length; r++) {
            var i = t.variants[r];
            var s = '<option value="' + i.id + '">' + i.title + "</option>";
            product.find("form.variants > select").append(s)
        }

        //new Shopify.OptionSelectors("product-select-" + t.id, { product: t,  onVariantSelected: selectCallbackQuickview  });
        if (t.options.length == 1) {
            $(".selector-wrapper:eq(0)").prepend("<label>" + t.options[0].name + "</label>")
        }
        product.find("form.variants .selector-wrapper label").each(function (n, r) {
            $(this).html(t.options[n].name)
        })
    } else {
        product.find("form.variants > select").remove();
        var o = '<input type="hidden" name="id" value="' + t.variants[0].id + '">';
        product.find("form.variants").append(o)
    }
}

function loadQuickViewSlider(product, r) {

    var s = Shopify.resizeImage(product.featured_image, "large");

    r.find(".jsquickview-featured-image").append('<a href="' + product.url + '"><img  class="jsquickchangemage" src="' + s + '" alt="' + product.title + '" title="' + product.title + '"/><div style="height: 100%; width: 100%; top:0px; left:-260px; z-index: 2000; position: absolute; display: none; background: url(' + window.loading_url + ') 50% 50% no-repeat;"></div></a>');
    if (product.images.length > 1) {
        var o = r.find(".tvmore-view-wrapper ul");
        for (i in product.images) {
            var u = Shopify.resizeImage(product.images[i], "large");
            var a = Shopify.resizeImage(product.images[i], "small");
            var f = '<li><a href="javascript:void(0)" data-image="' + u + '"><img src="' + a + '" alt="" /></a></li>';
            o.append(f)
        }
        o.find("a").click(function () {
            var t = r.find(".jsquickview-featured-image img");
            var product = r.find(".jsquickview-featured-image div");
            if (t.attr("src") != $(this).attr("data-image")) {
                t.attr("src", $(this).attr("data-image"));
                product.show();
                t.load(function (t) {
                    product.hide();
                    $(this).unbind("load");
                    product.hide()
                })
            }
        });
        if (o.hasClass("quickview-more-views-owlslider")) {
            initQuickViewMoreview(o)
        } else {
            initQuickViewMoreview(o)
        }
    } else {
        r.find(".tvmore-view-wrapper").remove();
    }
}

function initQuickviewAddToCart() {
    if ($(".package .jsquick-view .jsadd-to-cart-btn").length > 0) {
        $(".package .jsquick-view .jsadd-to-cart-btn").click(function () {

            var n = $(".package .jsquick-view select[name=id]").val();
            if (!n) {
                n = $(".package .jsquick-view input[name=id]").val()
            }
            var r = $(".package .jsquick-view input[name=quantity]").val();
            if (!r) {
                r = 1
            }
            var p = $('.package .jsquick-view .jstv-quick-view-product-title a').html();
            var a = $(".package .jsquick-view .jsquickview-featured-image img").attr("src");
            var amt = $('.package .jsquick-view .jstotal-price span span').html();


            doAjaxAddToCart(n, r, a, p, amt);
            closeQuickViewPopup();
            $('.package .jsquick-view').removeClass("open-in");
            $('.package .jsquick-view').removeClass("option-loader");
        })
    }
}

function closeQuickViewPopup() {
    $(".package .jsquick-view").fadeOut(500);
}

function initQuickViewMoreview(t) {
    if (t) {
        t.owlCarousel({
            loop: false,
            dots: false,
            nav: false,
            responsive: {
                0: {
                    items: 2
                },
                600: {
                    items: 3
                },
                1000: {
                    items: 4
                }
            }
        });
        $('.tvcms-quickview-pagination-wrapper .tv-quickview-prev').click(function (e) {
            e.preventDefault();
            $('.quickview-more-views-owlslider .owl-nav .owl-prev').trigger('click');
        });
        $('.tvcms-quickview-pagination-wrapper .tv-quickview-next').click(function (e) {
            e.preventDefault();
            $('.quickview-more-views-owlslider .owl-nav .owl-next').trigger('click');
        });
    }
}

function convertToSlug(e) {
    return e.toLowerCase().replace(/[^a-z0-9 -]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-")
}

function createQuickViewVariantsSwatch(product, quickviewTemplate) {
    if (product.variants.length > 1) { //multiple variants
        for (var i = 0; i < product.variants.length; i++) {
            var variant = product.variants[i];
            var option = '<option value="' + variant.id + '">' + variant.title + '</option>';
            quickviewTemplate.find('form.variants > select').append(option);
        }
        new Shopify.OptionSelectors("product-select-" + product.id, {
            product: product,
            onVariantSelected: selectCallbackQuickview
        });
        //start of quickview variant;
        var filePath = window.file_url.substring(0, window.file_url.lastIndexOf('?'));
        var assetUrl = window.asset_url.substring(0, window.asset_url.lastIndexOf('?'));
        var options = "";
        for (var i = 0; i < product.options.length; i++) {
            options += '<div class="swatch clearfix" data-option-index="' + i + '">';
            options += '<div class="header">' + product.options[i].name + '</div>';
            var is_color = false;
            if (/Color|Colour/i.test(product.options[i].name)) {
                is_color = true;
            }
            var optionValues = new Array();
            for (var j = 0; j < product.variants.length; j++) {
                var variant = product.variants[j];
                var value = variant.options[i];
                var valueHandle = this.convertToSlug(value);
                var forText = 'swatch-' + i + '-' + valueHandle;
                if (optionValues.indexOf(value) < 0) {
                    //not yet inserted
                    options += '<div data-value="' + value + '" class="swatch-element ' + (is_color ? "color" : "") + valueHandle + (variant.available ? ' available ' : ' soldout ') + '">';


                    options += '<input id="' + forText + '" type="radio" name="option-' + i + '" value="' + value + '" ' + (j == 0 ? ' checked ' : '') + (variant.available ? '' : ' disabled') + ' />';

                    if (is_color) {
                        options += '<label for="' + forText + '" style="background-color: ' + valueHandle + ';">&nbsp;<img class="crossed-out" src="' + assetUrl + '" alt="" /></label>';
                    } else {
                        options += '<label for="' + forText + '">' + value + '<img alt="" class="crossed-out" src="' + assetUrl + '" /></label>';
                    }
                    options += '</div>';
                    if (variant.available) {
                        $('.quick-view .swatch[data-option-index="' + i + '"] .' + valueHandle).removeClass('soldout').addClass('available').find(':radio').removeAttr('disabled');
                    }
                    optionValues.push(value);
                }
            }
            options += '</div>';
        }
        quickviewTemplate.find('form.variants > select').after(options);
        quickviewTemplate.find('.swatch :radio').change(function () {
            var optionIndex = $(this).closest('.swatch').attr('data-option-index');
            var optionValue = $(this).val();
            $(this)
                .closest('form')
                .find('.single-option-selector')
                .eq(optionIndex)
                .val(optionValue)
                .trigger('change');
        });
        if (product.available) {
            Shopify.optionsMap = {};
            Shopify.linkOptionSelectors(product);
        }
        //end of quickview variant
    } else { //single variant
        quickviewTemplate.find('form.variants > select').remove();
        var variant_field = '<input type="hidden" name="id" value="' + product.variants[0].id + '">';
        quickviewTemplate.find('form.variants').append(variant_field);
        if (window.show_multiple_currencies && window.shop_currency != jQuery("#currencies").val()) {
            Currency.convertAll(window.shop_currency, jQuery("#currencies").val(), "span.money", "money_format")
        }
    }
}
/*End Quick View*/

/*Start Dropdown Cart*/
$(document).on('click', '.jsbtn-remove', function (event) {
    event.preventDefault();
    var r = $(this).parents(".item").attr("id");
    r = r.match(/\d+/g);
    Shopify.removeItem(r, function (e) {
        doUpdateDropdownCart(e)
    })
});

function updateDropdownCart() {
    Shopify.getCart(function (e) {
        doUpdateDropdownCart(e)
    })
}

function doUpdateDropdownCart(n) {
    var r = '<li class="tvadd-to-cart-product item" id="cart-item-{ID}"><div class="tvcart-image-wrap"><a href="{URL}" title="{TITLE}" class="tvcmsproduct-cart-image"><img src="{IMAGE}" alt="{TITLE}"></a></div><div class="tvproduct-info-box"><a class="tvcart-dropdawn-product-title" href="{URL}">{TITLE}</a><span class="tvcart-product-quantity">{QUANTITY} X<span class="tvproduct-amount-price">{PRICE}</span></span><a href="javascript:void(0)" title="Remove This Item" class="remove jsbtn-remove"><i class="fa fa-trash-o" aria-hidden="true"></i></a></div></li>';

    $("#jscartCount").text(n.item_count);
    /*$("#minicart_total span.money").html(Shopify.formatMoney(n.total_price, window.money_format));*/

    $(".jstvadd-to-cart-product-total .jstv-product-price").html(Shopify.formatMoney(n.total_price, window.money_format));
    $("#jsslidedown-cart .jstvadd-to-cart-product-list").html("");
    if (n.item_count > 0) {
        for (var i = 0; i < n.items.length; i++) {
            var s = r;
            s = s.replace(/\{ID\}/g, n.items[i].id);
            s = s.replace(/\{URL\}/g, n.items[i].url);
            s = s.replace(/\{TITLE\}/g, n.items[i].title);
            s = s.replace(/\{QUANTITY\}/g, n.items[i].quantity);
            s = s.replace(/\{IMAGE\}/g, Shopify.resizeImage(n.items[i].image, "small"));
            s = s.replace(/\{PRICE\}/g, Shopify.formatMoney(n.items[i].price, window.money_format));

            $("#jsslidedown-cart .jstvadd-to-cart-product-list").append(s)
        }

        $("#jsslidedown-cart .jsbtn-remove").click(function (n) {
            n.preventDefault();
            var r = $(this).parents(".item").attr("id");
            r = r.match(/\d+/g);
            Shopify.removeItem(r, function (e) {
                doUpdateDropdownCart(e);
            })
        });
        if (checkNeedToConvertCurrency()) {
            Currency.convertAll(window.shop_currency, jQuery('#currencies').val(), '#jsslidedown-cart span.money', 'money_format')
            Currency.convertAll(window.shop_currency, jQuery('#currencies').val(), '#minicart_total span.money', 'money_format')

        }
    }
}

function checkNeedToConvertCurrency() {
    return Currency.currentCurrency != shopCurrency
}
$(document).on('click', '#jsslidedown-cart', function () {
    $("body").addClass('CartOpen');
    $("#jsslidedown-cart .jstvhas-items, #jsslidedown-cart .jstvcart-no-items").removeClass('active');
    if ($("#jsslidedown-cart .jstvadd-to-cart-product-list").children().length >= 0) {
        $("#jsslidedown-cart .jstvhas-items").addClass('active');
    } else {
        $("#jsslidedown-cart .jstvcart-no-items").addClass('active');
    }
});
$(document).on('click', '.full-wrapper-backdrop', function () {
    $("#jsslidedown-cart .jstvhas-items, #jsslidedown-cart .jstvcart-no-items").removeClass('active');
    $("body").removeClass('CartOpen');
});
/*End Dropdown Cart*/

/*Start Add To Cart*/
$(document).on('click', '.jsadd-cart-btn', function (n) {
    n.preventDefault();
    if ($(this).attr("disabled") != "disabled") {
        var r = $(this).parents(".jsitem-row");
        var i = $(r).attr("id");
        i = i.match(/\d+/g);

        var s = $("#jscart-form-" + i + " select[name=id]").val();
        if (!s) {
            s = $("#jscart-form-" + i + " input[name=id]").val()
        }
        var o = $("#jscart-form-" + i + " select[name=quantity]").val();
        if (!o) {
            o = 1
        }
        var a = $(r).find(".featured-image").attr("src");
        var p = $(r).find(".jsgrid-link__title").text();
        var amt = $(r).find(".jsproduct-price-and-shipping .price").text();
        doAjaxAddToCart(s, o, a, p, amt);

    }
    return false
});

function doAjaxAddToCart(n, r, a, p, amt) {
    $.ajax({
        type: "post",
        url: "/cart/add.js",
        data: "quantity=" + r + "&id=" + n,
        dataType: "json",
        beforeSend: function () {
            showLoading();
        },
        success: function (n) {
            hideLoading();
            showModal(".jsajax-success-modal");
            $(".jsajax-success-modal").find(".jsajax-product-image").attr("src", a);
            $(".jsajax-success-modal").find(".jsadded-to-wishlist").hide();
            // $(".jsajax-success-modal").find(".jsadded-to-cart").show();
            $(".jsajax-success-modal").find(".jsajax-product-title").html(p);
            $(".jsajax-success-modal").find(".jsajax_price").text(amt);
            updateDropdownCart();
        },
        error: function (n, r) {
            hideLoading();
            $(".jsajax-error-message").text($.parseJSON(n.responseText).description);
            showModal(".jsajax-error-modal");
        }
    })
}
/*End Add To Cart*/

/*currency*/
jQuery.cookie = function (b, j, m) {
    if (typeof j != "undefined") {
        m = m || {}; if (j === null) {
            j = "";
            m.expires = -1
        } var e = ""; if (m.expires && (typeof m.expires == "number" || m.expires.toUTCString)) {
            var f; if (typeof m.expires == "number") {
                f = new Date();
                f.setTime(f.getTime() + (m.expires * 24 * 60 * 60 * 1000))
            } else { f = m.expires } e = "; expires=" + f.toUTCString()
        } var l = m.path ? "; path=" + (m.path) : ""; var g = m.domain ? "; domain=" + (m.domain) : ""; var a = m.secure ? "; secure" : "";
        document.cookie = [b, "=", encodeURIComponent(j), e, l, g, a].join("")
    } else { var d = null; if (document.cookie && document.cookie != "") { var k = document.cookie.split(";"); for (var h = 0; h < k.length; h++) { var c = jQuery.trim(k[h]); if (c.substring(0, b.length + 1) == (b + "=")) { d = decodeURIComponent(c.substring(b.length + 1)); break } } } return d }
};
var cookilast = "themecurrency";
var cvalue = Currency.currentCurrency;
jQuery.cookie(cookilast, cvalue, { expires: 1, path: '/' });

function convert_currency(value) {
    var newCurrency = Currency.currentCurrency;
    console.log("newCurrency" + newCurrency);
    var oldCurrency = shopCurrency;
    console.log("oldCurrency" + oldCurrency);
    if (isNaN(value)) {
        value = 0.0;
    }
    var cents = 0.0;
    var oldFormat = Currency.moneyFormats['USD'][Currency.format] || '';
    var newFormat = Currency.moneyFormats[newCurrency][Currency.format] || '';
    /*var newFormat = Currency.moneyFormats['INR'][Currency.format] || '';*/
    if (oldFormat.indexOf('amount_no_decimals') !== -1) {
        cents = Currency.convert(parseInt(value, 10) * 100, oldCurrency, newCurrency);
    } else if (oldCurrency === 'JOD' || oldCurrency == 'KWD' || oldCurrency == 'BHD') {
        cents = Currency.convert(parseInt(value, 10) / 10, oldCurrency, newCurrency);
    } else {
        cents = Currency.convert(parseInt(value, 10), oldCurrency, newCurrency);
    }
    var my_data = Currency.formatMoney(cents, newFormat);
    return my_data;
}

/* end currency */

/*quantity plus*/
$(document).on('click', '.jsproductall', function () {
    var n = $(this).parent().find('.jstvproduct-cart-quentity').val();
    r = 1;
    if ($(this).text() == "+") {
        r = parseInt(n) + 1
    } else if (n > 1) {
        r = parseInt(n) - 1
    }
    $(this).parent().find('.jstvproduct-cart-quentity').val(r);
});
/*quantity plus*/

function singleproductthumbimages() {
    if (document.body.clientWidth <= 575) {
        $('.tv-product-main-image-box').insertBefore('.tv-product-gallery-slider');
    } else {
        $('.tv-product-main-image-box').insertAfter('.tv-product-gallery-slider');
    }
}

/*single product image*/
singleproductthumbimages();

$(window).resize(function () {
    singleproductthumbimages();
});

/*single product image*/

/*********************** Start Product Category page View ******************************/
// Start Grid View
function removeClassesOfView() {
    $('#products').removeClass('grid grid-2 list list-2 catalog');
}

$(document).on('click', '.tvcmsproduct-grid-list .tvproduct-grid', function () {
    removeClassesOfView();
    $('#products').addClass('grid');
});
// End Grid View

// Start Grid-2 View
$(document).on('click', '.tvcmsproduct-grid-list .tvproduct-grid-2', function () {
    removeClassesOfView();
    $('#products').addClass('grid-2');
});
// End Grid-2 View

// Start List View
$(document).on('click', '.tvcmsproduct-grid-list .tvproduct-list', function () {
    removeClassesOfView();
    $('#products').addClass('list');
});
// End List View

// Start List-2 View
$(document).on('click', '.tvcmsproduct-grid-list .tvproduct-list-2', function () {
    removeClassesOfView();
    $('#products').addClass('list-2');
});
// End List-2 View

// Start catalog View
$(document).on('click', '.tvcmsproduct-grid-list .tvproduct-catalog', function () {
    removeClassesOfView();
    $('#products').addClass('catalog');
});
// End catalog View
/*********************** End Product Category page View ******************************/

/****************** Start Product special date Js *******************************************/
var result = setInterval(function () {
    $('.tvproduct-timer').each(function () {
        var time = $(this).attr('data-end-time');
        var countDownDate = new Date(time.replace(/ /g, "T") + 'Z');
        var now = new Date().getTime();
        var distance = countDownDate - now;
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);
        var data = days + '' + hours + '' + minutes + '' + seconds + '';

        $(this).find('.tvproduct-timer-box .days').html(days);
        $(this).find('.tvproduct-timer-box .hours').html(hours);
        $(this).find('.tvproduct-timer-box .minutes').html(minutes);
        $(this).find('.tvproduct-timer-box .seconds').html(seconds);
        $(this).find('.complated').hide();

        if (distance < 0) {
            clearInterval(x);
            data = "complate";
            $(this).find('.tvproduct-timer-wrapper').hide();
            $(this).find('.tvproduct-timer-complated').show(data);
        }
    });
}, 1000);
/****************** End Product special date Js *******************************************/

/******************* Start Menu Sticky Js ********************************************/
var status_sticky = $('#stickyvalue').val();
if (status_sticky == "true") {
    menuStickyJs();
    $(document).on('scroll', function () {
        var menu_sticky = true;
        if (storage.get("menu-sticky") != undefined) {
            var menu_sticky = storage.get("menu-sticky");
        }
        if (menu_sticky == true) {
            menuStickyJs();
        } else {
            $('.desktop-megamenu').removeClass('sticky');
        }
        bottomTotop();
    });

    function menuStickyJs() {
        var checkMenuSticky = $('body').attr('data-menu-sticky');
        if (checkMenuSticky == '1') {
            var startMenuStickyHeight = 450;
            var mobileViewSize = 991;
            var scrollHeight = $(document).scrollTop();
            if (document.body.clientWidth > mobileViewSize) {
                // Desktop View Sticky
                if (scrollHeight > startMenuStickyHeight) {
                    $('.desktop-megamenu').addClass('sticky');
                    $('.tvmain-content-wrapper').css('margin-top', $('.desktop-megamenu').height() + 'px');
                } else {
                    $('.desktop-megamenu').removeClass('sticky');
                    $('.tvmain-content-wrapper').css('margin-top', '0px');
                }
            }
        }
    }

    function bottomTotop() {
        var startMenuStickyHeight = 450;
        var scrollHeight = $(document).scrollTop();
        if (scrollHeight > startMenuStickyHeight) {
            $('.tvbottom-to-top').fadeIn('slow');
        } else {
            $('.tvbottom-to-top').fadeOut('slow');
        }
    }
}
/******************* End Menu Sticky Js ********************************************/

/*left-right panal*/
$(document).on('click', '#column-left .tvleft-column-close-btn, #column-right .tvright-column-close-btn', function () {
    if ($(this).parent().parent().parent().hasClass('open')) {
        $('.tv-left-right-panel-hide').removeClass('open');
        $('.modal-backdrop.fade.in').remove();
    }
});
// Left Right Panel Hide show
$(document).on('keyup', function (e) {
    if (e.key === "Escape") {
        $("#jsmodal-compare").fadeOut(500);
        $('body').removeClass("modal-open");
        $('.jstvsearch-main-box').removeClass('open');
        $(".package #jstv-quick-view-modal").fadeOut(500);
        $(".jsajax-success-modal").fadeOut(500);

        if ($('#column-left .tvleft-column-close-btn, #column-right .tvright-column-close-btn').parent().parent().hasClass('open')) {
            $('.tv-left-right-panel-hide').removeClass('open');
            $('.modal-backdrop.fade.in').remove();
        }
    }
});
// Left Panel Hide show
$(document).on('click', '.tvcms-left-column-wrapper .tv-left-pannal-btn-wrapper', function (e) {
    e.preventDefault();
    if ($('#column-left').hasClass('open')) {
        $('#column-left').removeClass('open');
        $('.modal-backdrop.fade.in').remove();
    } else {
        $('#column-left').addClass('open');
        $('body').append('<div class="modal-backdrop fade in"></div>');
        e.stopPropagation();
    }
});
// Right Panel Hide show
$(document).on('click', '.tvcms-right-column-wrapper .tv-right-pannal-btn-wrapper', function (e) {
    e.preventDefault();
    if ($('#column-right').hasClass('open')) {
        $('#column-right').removeClass('open');
        $('.modal-backdrop.fade.in').remove();
    } else {
        $('#column-right').addClass('open');
        $('body').append('<div class="modal-backdrop fade in"></div>');
        e.stopPropagation();
    }
});



// Left - right Panel Close. 
$(document).on('click', '.modal-backdrop.fade.in', function () {
    if ($('#column-left.tv-left-right-panel-hide, #column-right.tv-left-right-panel-hide').hasClass('open')) {
        $('#column-left.tv-left-right-panel-hide, #column-right.tv-left-right-panel-hide').removeClass('open');
        $('.modal-backdrop.fade.in').remove();
    }
});

/*left-right panal*/
var checkurl = decodeURIComponent(window.location.href);
if (checkurl.indexOf('/collections/') > 1) {
    /*filter*/
    $(document).on('change', '.jsfilter', function () {

        var search = $(this).val();
        var geturl = decodeURIComponent(window.location.href);
        var urlvalpos = geturl.indexOf('='); // urlvalpos= -1


        var urlval = geturl.substring(urlvalpos + 1);
        if (urlvalpos > 1) {
            if (geturl.indexOf('?sort_by') > 1) {
                var newurl = urlval.split('?sort_by');
                var lasturl = search + "&sort_by=" + newurl[0];
            } else {
                var urlval = geturl.substring(urlvalpos + 1); //urlval = adidas
                if (geturl.indexOf('&sort_by=') > 1) {
                    var newurl = urlval.split('&');
                    var lasturl = newurl[0] + "+" + search + '&' + newurl[1];
                } else {
                    var lasturl = urlval + "+" + search; //lasturl = adidas+black
                }
            }
        } else {
            var lasturl = search; //lastur= adidas
        }
        url = "?constraint=" + lasturl; //url= ?constraint=adidas

        if ($(this).prop('checked') == true) {
            document.location.href = url;
        } else {
            var url = replaceAll(url, search, "");
            if (url.indexOf('++') > 1) {
                var url = url.replace("++", "+");
            }
            if (url.indexOf('=+') > 1) {
                var url = url.replace("=+", "=");
            }
            var lastcharacter = url[url.length - 1];
            if (lastcharacter == "=") {
                var url = url.slice(0, -1);
            }
            if (lastcharacter == "+") {
                var url = url.slice(0, -1);
            }
            if (url.indexOf('+&') > 1) {
                var url = url.replace("+&", "&");
            }
            if (url.indexOf('=&') > 1) {
                var url = url.replace("constraint=&", "");
            }
            document.location.href = url;
        }
    });

    // function escapeRegExp(string) {
    //     return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    // }

    // function replaceAll(str, term, replacement) {
    //     return str.replace(new RegExp(escapeRegExp(term), 'g'), replacement);
    // }

    $(document).ready(function () {
        compare = storage.get('compare');
        $('.jstvcompare-count-product').text(Object.keys(compare).length);
        var geturl = decodeURIComponent(window.location.href);
        var checkpos = geturl.indexOf('all?constraint=');
        var urlvalpos = geturl.indexOf('=');
        var lastpos = geturl.indexOf('&');
        if (lastpos < 1) {
            lastpos = 1000;
        }
        if (checkpos > 1) {
            var urlval = geturl.substring(urlvalpos + 1, lastpos);
            var data = urlval.split('+');
            $.each(data, function (index, value) {
                $(":checkbox[value=" + value + "]").prop("checked", "true");
            });
        } else if (geturl.indexOf('/collections/all?constraint') > 1) {
            var urlval = geturl.substring(urlvalpos + 1, lastpos);
            $(":checkbox[value=" + urlval + "]").prop("checked", "true");
        }
    });


    /*filter*/
}
$(document).on('click', '.tvsearch-btn', function () {
    $('.jstvsearch-btn-wrap').toggleClass('open');
});

$(window).load(function () {
    $('.tvcms-loading-overlay').fadeOut('slow');
});
$(document).on('mouseenter', '.tvmyaccount-dropdown', function () {
    if ($('.tvdropdown-menu-my-account').hasClass('open')) {
        $('.tvdropdown-menu-my-account').removeClass('open').stop(false).slideUp(100, "swing");
    } else {
        $('.tvdropdown-menu-my-account').addClass('open').stop(false).slideDown(100, "swing");
    }
    // $(this).toggleClass('open');
});

$(document).on('click', '.tvmyaccount-dropdown', function () {
    if ($('.tvdropdown-menu-my-account').hasClass('open')) {
        $('.tvdropdown-menu-my-account').removeClass('open').stop(false).slideUp(100, "swing");
    } else {
        $('.tvdropdown-menu-my-account').addClass('open').stop(false).slideDown(100, "swing");
    }
    // $(this).toggleClass('open');
});

$(document).on('mouseleave', '.tvmyaccount-dropdown', function () {
    $('.tvdropdown-menu-my-account').removeClass('open').stop(false).slideUp(100, "swing");
});

$(document).on('click', '.tvmyaccount-dropdown-btn', function () {
    $('.jstvsearch-btn-wrap').removeClass('open');
    // $('.tvmyaccount-dropdown').toggleClass('open');
    $('.jstvsearch-main-box').removeClass('open');
    $('.desktop-megamenu').removeClass('open');
});

$(document).on('click', '.tv-moblie-menu-device-wrapper', function () {
    $('.tvmenu-tool-wrap').addClass('open');
});
$(document).on('click', '.jstvsearch-btn-wrap', function () {
    $('.jstvsearch-main-box').toggleClass('open');
    $('.tvmyaccount-dropdown').removeClass('open');
    $('.desktop-megamenu').removeClass('open');
});
$(document).on('click', '.jstvsearch-close-btn', function () {
    $('.jstvsearch-main-box').toggleClass('open');
});

$(document).on('click', '.jstvvertical-show-category', function () {
    $('.jstvvertical-hide-category').show();
});
$(document).on('click', '.jstvvertical-hide-category', function () {
    $('.jstvvertical-show-category').toggle();
});

$(document).on('click', '.jstvall-Categories-icon', function () {
    $('.jstvverticalmenu-dropdown').toggle('open');
});
$(document).on('click', '.jstvall-Categories-icon', function () {
    $('.jstvallcategories-wrapper').toggleClass('open');
});

$(document).on('click', '#jstv-compare-close, .overlay', function () {
    $("#jsmodal-compare").fadeOut(500);
});
$(document).on('click', '.jstv-quickview-close, .tv-quick-view-overlay', function () {
    event.preventDefault();
    $(".package #jstv-quick-view-modal").fadeOut(500);
    $('body').removeClass("modal-open");
});

$(document).on('click', '.jsclose-modal', function (event) {
    event.preventDefault();
    $(".jsajax-success-modal").fadeOut(500);
});

$(document).on('click', ".tvmobile-menu-overlay", function () {
    $(".desktop-megamenu").removeClass('open');
});

function showModal(n) {
    $(n).fadeIn(500);
    var KidsTimeout = setTimeout(function () {
        $(n).fadeOut(500)
    }, 2e3)
}

function showLoading() {
    $(".jstvloading-modal").css("display", "block");
}

function hideLoading() {
    $(".jstvloading-modal").css("display", "none");
}

if (document.body.clientWidth < 992) {
    $(document).on('click', '.tvmobile-dropdown', function () {
        $(this).parent('.tvmenu-dropdown').find('.site-nav-dropdown').slideToggle('show');
    });
    $(document).on('click', '.tv-mobile-close-menu', function () {
        $('.tvmenu-tool-wrap').removeClass('open');
    });
}
/************ Start To Change Left Column Position in Mobile Size *********************************/
var mobileViewSize = 991;

changePositionLeftColumnMobileView();

$(window).resize(function () {
    changePositionLeftColumnMobileView();
    // changePositionlogoMobileView();
});

function changePositionLeftColumnMobileView() {
    if (document.body.clientWidth > 1199) {
        $('#column-left').insertBefore('#content-wrapper');
    } else {
        $('#column-left').insertAfter('#content-wrapper');
    }
}

var changepositionViewSize = 768;
// changePositionlogoMobileView();

function changePositionlogoMobileView() {
    if (document.body.clientWidth < changepositionViewSize) {
        // alert(123);
        $('.tvcmslogo-wrapper').insertBefore('.tvcms-header-menu');
    } else {
        $('.tvcmslogo-wrapper').insertAfter('.tvcms-header-menu');
    }
}

/************ End To Change Left Column Position in Mobile Size *********************************/
/******************************** tooltip ************************/
var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl)
})

$(function () {
    'use strict';
    var popoverConfig = {
        trigger: 'hover',
        template: [
            '<div class="popover tvtooltip" role="tooltip">',
            '<div class="popover-arrow"></div>',
            '<h3 class="popover-title"></h3>',
            '<div class="popover-content"></div>',
            '</div>'
        ].join(''),
        placement: 'top',
        container: 'body',
    };

    initPopovers();

    function initPopovers() {
        $('[data-toggle="tvtooltip"]').popover(popoverConfig);
    }
});

/******************* end tooltip ***********************/

/******************* Start Menu Sticky Js *******************/
$(document).on('scroll', function () {
    // var checkMenuSticky = $('body').attr('data-menu-sticky');
    var mobileViewSize = 991;
    var stickyClass = '.desktop-megamenu';

    var menuSticky = 'true';
    if (typeof storage.get("menu-sticky") == undefined && storage.get("menu-sticky") == false) {
        menuSticky = 'false';
    }

    if ($('body').attr('data-menu-sticky') == "true" && menuSticky == "true") {
        var startMenuStickyHeight = 900;
        var scrollHeight = $(document).scrollTop();
        if (document.body.clientWidth > mobileViewSize) {
            if (scrollHeight > startMenuStickyHeight) {
                $(stickyClass).addClass('sticky');
                $('#MainContent').css('margin-top', $(stickyClass).height() + 'px');
            } else {
                $(stickyClass).removeClass('sticky');
                $('#MainContent').css('margin-top', '0px');
            }
        }
    }
});
/******************* End Menu Sticky Js *******************/

var mobileViewSize = 991;

function showView_1() {
    if (document.body.clientWidth <= mobileViewSize) { //for mobile view
        moveDataInMobileView('#shopify-section-tvheader-1 .tvcmslogo-wrapper', '#shopify-section-tvheader-1 #tvcmsmobile-header-logo');
        moveDataInMobileView('#shopify-section-tvheader-1 #tvsearchid', '#shopify-section-tvheader-1 .tvmobile-search');
        moveDataInMobileView('#shopify-section-tvheader-1 .tvheader-menu-site-nav', '#shopify-section-tvheader-1 #tvcmsmobile-horizontal-menu');
        moveDataInMobileView('#shopify-section-tvheader-1 .header-right', '#shopify-section-tvheader-1 .tvcmsmobile-header-right-icon');
        moveDataInMobileView('#shopify-section-tvheader-1 .tvsignin-link', '#shopify-section-tvheader-1 .tvcmsmobile-header-login');
        moveDataInMobileView('#shopify-section-tvheader-1 .tvcurrency-info', '#shopify-section-tvheader-1 #tvcmsmobile-horizontal-menu .tvmobile-new-transfer');
    } else { //for desktop view
        moveDataInDesktopView('#shopify-section-tvheader-1 .tvcurrency-info', '#shopify-section-tvheader-1 #tvcmsmobile-horizontal-menu .tvmobile-new-transfer');
        moveDataInDesktopView('#shopify-section-tvheader-1 .tvcmslogo-wrapper', '#shopify-section-tvheader-1 #tvcmsmobile-header-logo');
        moveDataInDesktopView('#shopify-section-tvheader-1 #tvsearchid', '#shopify-section-tvheader-1 .tvmobile-search');
        moveDataInDesktopView('#shopify-section-tvheader-1 .tvheader-menu-site-nav', '#shopify-section-tvheader-1 #tvcmsmobile-horizontal-menu');
        moveDataInDesktopView('#shopify-section-tvheader-1 .header-right', '#shopify-section-tvheader-1 .tvcmsmobile-header-right-icon');
        moveDataInDesktopView('#shopify-section-tvheader-1 .tvsignin-link', '#shopify-section-tvheader-1 .tvcmsmobile-header-login');
    }
}

function showView_2() {
    if (document.body.clientWidth <= mobileViewSize) { //for mobile view
        moveDataInMobileView('#shopify-section-tvheader-2 .tvcmslogo-wrapper', '#shopify-section-tvheader-2 #tvcmsmobile-header-logo');
        moveDataInMobileView('#shopify-section-tvheader-2 #tvsearchid', '#shopify-section-tvheader-2 .tvmobile-search');
        moveDataInMobileView('#shopify-section-tvheader-2 .tvheader-menu-site-nav', '#shopify-section-tvheader-2 #tvcmsmobile-horizontal-menu');
        moveDataInMobileView('#shopify-section-tvheader-2 .header-right', '#shopify-section-tvheader-2 .tvcmsmobile-header-right-icon');
        moveDataInMobileView('#shopify-section-tvheader-2 .tvsignin-link', '#shopify-section-tvheader-2 .tvcmsmobile-header-login');
        moveDataInMobileView('#shopify-section-tvheader-2 .tvcurrency-info', '#shopify-section-tvheader-2 #tvcmsmobile-horizontal-menu .tvmobile-new-transfer');
    } else { //for desktop view
        moveDataInDesktopView('#shopify-section-tvheader-2 .tvcurrency-info', '#shopify-section-tvheader-2 #tvcmsmobile-horizontal-menu .tvmobile-new-transfer');
        moveDataInDesktopView('#shopify-section-tvheader-2 .tvcmslogo-wrapper', '#shopify-section-tvheader-2 #tvcmsmobile-header-logo');
        moveDataInDesktopView('#shopify-section-tvheader-2 #tvsearchid', '#shopify-section-tvheader-2 .tvmobile-search');
        moveDataInDesktopView('#shopify-section-tvheader-2 .tvheader-menu-site-nav', '#shopify-section-tvheader-2 #tvcmsmobile-horizontal-menu');
        moveDataInDesktopView('#shopify-section-tvheader-2 .header-right', '#shopify-section-tvheader-2 .tvcmsmobile-header-right-icon');
        moveDataInDesktopView('#shopify-section-tvheader-2 .tvsignin-link', '#shopify-section-tvheader-2 .tvcmsmobile-header-login');
    }
}

function showView_3() {
    if (document.body.clientWidth <= mobileViewSize) { //for mobile view
        moveDataInMobileView('#shopify-section-tvheader-3 .tvcurrency-info', '#shopify-section-tvheader-3 #tvcmsmobile-horizontal-menu .tvmobile-new-transfer');
        moveDataInMobileView('#shopify-section-tvheader-3 .tvcmslogo-wrapper', '#shopify-section-tvheader-3 #tvcmsmobile-header-logo');
        moveDataInMobileView('#shopify-section-tvheader-3 #tvsearchid', '#shopify-section-tvheader-3 .tvmobile-search');
        moveDataInMobileView('#shopify-section-tvheader-3 .tvheader-menu-site-nav', '#shopify-section-tvheader-3 #tvcmsmobile-horizontal-menu');
        moveDataInMobileView('#shopify-section-tvheader-3 .header-right', '#shopify-section-tvheader-3 .tvcmsmobile-header-right-icon');
        moveDataInMobileView('#shopify-section-tvheader-3 .tvsignin-link', '#shopify-section-tvheader-3 .tvcmsmobile-header-login');
    } else { //for desktop view
        moveDataInDesktopView('#shopify-section-tvheader-3 .tvcurrency-info', '#shopify-section-tvheader-3 #tvcmsmobile-horizontal-menu .tvmobile-new-transfer');
        moveDataInDesktopView('#shopify-section-tvheader-3 .tvcmslogo-wrapper', '#shopify-section-tvheader-3 #tvcmsmobile-header-logo');
        moveDataInDesktopView('#shopify-section-tvheader-3 #tvsearchid', '#shopify-section-tvheader-3 .tvmobile-search');
        moveDataInDesktopView('#shopify-section-tvheader-3 .tvheader-menu-site-nav', '#shopify-section-tvheader-3 #tvcmsmobile-horizontal-menu');
        moveDataInDesktopView('#shopify-section-tvheader-3 .header-right', '#shopify-section-tvheader-3 .tvcmsmobile-header-right-icon');
        moveDataInDesktopView('#shopify-section-tvheader-3 .tvsignin-link', '#shopify-section-tvheader-3 .tvcmsmobile-header-login');
    }
}

function showView_4() {
    if (document.body.clientWidth <= mobileViewSize) { //for mobile view
        moveDataInMobileView('#shopify-section-tvheader-4 .tvcmslogo-wrapper', '#shopify-section-tvheader-4 #tvcmsmobile-header-logo');
        moveDataInMobileView('#shopify-section-tvheader-4 #tvsearchid', '#shopify-section-tvheader-4 .tvmobile-search');
        moveDataInMobileView('#shopify-section-tvheader-4 .tvheader-menu-site-nav', '#shopify-section-tvheader-4 #tvcmsmobile-horizontal-menu');
        moveDataInMobileView('#shopify-section-tvheader-4 .header-right', '#shopify-section-tvheader-4 .tvcmsmobile-header-right-icon');
        moveDataInMobileView('#shopify-section-tvheader-4 .tvsignin-link', '#shopify-section-tvheader-4 .tvcmsmobile-header-login');
    } else { //for desktop view
        moveDataInDesktopView('#shopify-section-tvheader-4 .tvcmslogo-wrapper', '#shopify-section-tvheader-4 #tvcmsmobile-header-logo');
        moveDataInDesktopView('#shopify-section-tvheader-4 #tvsearchid', '#shopify-section-tvheader-4 .tvmobile-search');
        moveDataInDesktopView('#shopify-section-tvheader-4 .tvheader-menu-site-nav', '#shopify-section-tvheader-4 #tvcmsmobile-horizontal-menu');
        moveDataInDesktopView('#shopify-section-tvheader-4 .header-right', '#shopify-section-tvheader-4 .tvcmsmobile-header-right-icon');
        moveDataInDesktopView('#shopify-section-tvheader-4 .tvsignin-link', '#shopify-section-tvheader-4 .tvcmsmobile-header-login');
    }
}

function showView_5() {
    if (document.body.clientWidth <= mobileViewSize) { //for mobile view
        moveDataInMobileView('#shopify-section-tvheader-5 .tvcurrency-info', '#shopify-section-tvheader-5 #tvcmsmobile-horizontal-menu .tvmobile-new-transfer');
        moveDataInMobileView('#shopify-section-tvheader-5 .tvcmslogo-wrapper', '#shopify-section-tvheader-5 #tvcmsmobile-header-logo');
        moveDataInMobileView('#shopify-section-tvheader-5 #tvsearchid', '#shopify-section-tvheader-5 .tvmobile-search');
        moveDataInMobileView('#shopify-section-tvheader-5 .tvheader-menu-site-nav', '#shopify-section-tvheader-5 #tvcmsmobile-horizontal-menu');
        moveDataInMobileView('#shopify-section-tvheader-5 .header-right', '#shopify-section-tvheader-5 .tvcmsmobile-header-right-icon');
        moveDataInMobileView('#shopify-section-tvheader-5 .tvsignin-link', '#shopify-section-tvheader-5 .tvcmsmobile-header-login');
    } else { //for desktop view
        moveDataInDesktopView('#shopify-section-tvheader-5 .tvcurrency-info', '#shopify-section-tvheader-5 #tvcmsmobile-horizontal-menu .tvmobile-new-transfer');
        moveDataInDesktopView('#shopify-section-tvheader-5 .tvcmslogo-wrapper', '#shopify-section-tvheader-5 #tvcmsmobile-header-logo');
        moveDataInDesktopView('#shopify-section-tvheader-5 #tvsearchid', '#shopify-section-tvheader-5 .tvmobile-search');
        moveDataInDesktopView('#shopify-section-tvheader-5 .tvheader-menu-site-nav', '#shopify-section-tvheader-5 #tvcmsmobile-horizontal-menu');
        moveDataInDesktopView('#shopify-section-tvheader-5 .header-right', '#shopify-section-tvheader-5 .tvcmsmobile-header-right-icon');
        moveDataInDesktopView('#shopify-section-tvheader-5 .tvsignin-link', '#shopify-section-tvheader-5 .tvcmsmobile-header-login');
    }
}


function changePositionComapreWishlist_1() {
    if (document.body.clientWidth > 991) {
        $('#shopify-section-tvheader-1 .tvcurrency-info').insertAfter('#shopify-section-tvheader-1 .tvcustom-text');
        $('#shopify-section-tvheader-2 .tvcurrency-info').insertAfter('#shopify-section-tvheader-2 .tvcustom-text');
        $('#shopify-section-tvheader-3 .tvcurrency-info').insertAfter('#shopify-section-tvheader-3 .tvcustom-text');
        $('#shopify-section-tvheader-4 .tvcurrency-info').insertAfter('#shopify-section-tvheader-4 .tvcustom-text');
        $('#shopify-section-tvheader-5 .tvcurrency-info').insertBefore('#shopify-section-tvheader-5 .tvcmslogo-wrapper');
    } else {
        $('#shopify-section-tvheader-1 .tvcurrency-info').insertAfter('#shopify-section-tvheader-1 .site-nav');
        $('#shopify-section-tvheader-2 .tvcurrency-info').insertAfter('#shopify-section-tvheader-2 .site-nav');
        $('#shopify-section-tvheader-3 .tvcurrency-info').insertAfter('#shopify-section-tvheader-3 .site-nav');
        $('#shopify-section-tvheader-4 .tvcurrency-info').insertAfter('#shopify-section-tvheader-4 .site-nav');
        $('#shopify-section-tvheader-5 .tvcurrency-info').insertAfter('#shopify-section-tvheader-5 .site-nav');
    }
}

function moveDataInMobileView(desktopClass, mobileClass) {
    if ($(desktopClass).html() != '') {
        $(mobileClass).html($(desktopClass).html());
        $(desktopClass).html('');
    }
}

function moveDataInDesktopView(desktopClass, mobileClass) {
    if ($(mobileClass).html() !== '') {
        $(desktopClass).html($(mobileClass).html());
        $(mobileClass).html('');
    }
}

showView_1(); //default landing call for mobile view
showView_2(); //default landing call for mobile view
showView_3(); //default landing call for mobile view
showView_4(); //default landing call for mobile view
showView_5(); //default landing call for mobile view
blogHomepageSliderShow();
// changePositionComapreWishlist_1();

$(window).resize(function () {
    showView_1();
    showView_2();
    showView_3();
    showView_4();
    showView_5();
    blogHomepageSliderShow();
    // changePositionComapreWishlist_1();
});

/***************Blog Slider***************/
function blogHomepageSliderShow() {
    if (mobileViewSize >= document.body.clientWidth) {
        $('#tvmobile').show();
        $('#tvdesktop').hide();

        $('.tvcmsblog-home #tvmobile').owlCarousel({
            loop: false,
            dots: false,
            nav: false,
            responsive: {
                0: { items: 1 },
                320: { items: 1, slideBy: 1 },
                400: { items: 1, slideBy: 1 },
                768: { items: 2, slideBy: 1 },
                992: { items: 2, slideBy: 1 }
            },
        });
        $('.tvcmsblog-home-slider-prev').click(function (e) {
            e.preventDefault();
            $('#tvmobile.owl-nav .owl-prev').trigger('click');
        });

        $('.tvcmsblog-home-slider-next').click(function (e) {
            e.preventDefault();
            $('#tvmobile .owl-nav .owl-next').trigger('click');
        });
    } else {
        $('#tvmobile').hide();
        $('#tvdesktop').show();
    }
}
/********************Category Last Child Add class********************/
$('#shopify-section-sidebar-category ul.product-categories > li.tvcategory-menu-submenu').last().addClass('last');

$(document).on('click', '.jscomparelink', function (event) {
    // event.preventDefault();
    var compare = storage.get('compare');
    modal_compare(compare);
});

$(document).ready(function () {
    var compare = storage.get('compare');
    $('.jstvcompare-count-product').text(Object.keys(compare).length);
    if ($.cookie("totalwish") != null) {
        $('.jstvwishlist-count-number').text($.cookie("totalwish"));
    } else {
        $('.jstvwishlist-count-number').text("0");
    }
});